import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/seller-promotions")({
	component: SellerPromotionsLayout,
})

function SellerPromotionsLayout() {
	return <Outlet />
}
